<template>
    <div class="div_outer_box">
        <div class="deposit_demo_video_section" >
            <div class="custom_container">
                <div class="withdraws_video_sec">
                    <div v-for="(tut,tutKey,index) in tutorialVideosData" :key="index">
                        <div class="withdraws-video-con" v-if="tut">
                            <div class="wallet_thm_title">
                                <h2>{{ $t(`how-to-${type == 2 ? 'deposit' : 'withdraw'}`, `How To ${type == 2 ? 'deposit' : 'withdraw'}`) }} 
                                    ({{ tutKey }})</h2>
                            </div>
                            <iframe width="100%" height="180" :src="tut" :title="tutKey" frameborder="0" allowfullscreen="allowfullscreen"> </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>
<script>
export default {
    name: 'TutorialVideo',
    props:['type'],
    inject: ['walletConfig'],
     computed: {
        tutorialVideosData() {
            if(this.type == 2)
                return this.walletConfig?.deposit_video;
            else
                return this.walletConfig?.withdrawal_video;
        },
    },
}
</script>